import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { mdiClipboardTextClock, mdiClipboardTextOff } from '@mdi/js'
import { useDispatch } from 'react-redux'
import './styles.scss'
import { useAppSelector } from '../../../../store/hooks'
import { TabData } from '../../../../components/Tab/types'
import Section, { SectionBox, SectionOption } from '../../../../components/Section'
import Modal from '../../../../components/Modal'
import getHistoricoColeta from './scripts/getHistoricoColeta'
import getHistoricoColetaNaoConformidade from './scripts/getHistoricoColetaNaoConformidade'
import TableListarHistoricoColeta from './Components/TableListarHistoricoColeta'
import Tab from '../../../../components/Tab'
import Dados from './tabs/dados'
import MonMensal from './tabs/monMensal'
import MonAnual from './tabs/monAnual'
import Endereco from './tabs/endereco'
import Contato from './tabs/contato'
import PontoColeta from './tabs/pontoColeta'
import getPontosColeta from './scripts/getPontosColeta'
import getAbastecimento from './scripts/getAbastecimento'
import TabHidrometro from './tabs/hidrometro'
import TableListarHistoricoNaoConformidade from './Components/TableListarHistoricoNaoConformidade'
import getRoteiro from './scripts/getRoteiro'
import getRamoAtividade from './scripts/getRamoAtividade'
import get from '../Parametro/Scripts/get'
import getColor from './scripts/getColor'

const Client: React.FC = () => {    

    const { idCliente } = useParams<any>()

    const dispatch = useDispatch()
    const { requestGetHistoricoColeta, requestGetHistoricoColetaNaoConformidade, historicoColeta, historicoColetaNaoConformidade, cliente } = useAppSelector(state => state.ClientsReducer)

    const [openRelatorioColeta, setOpenRelatorioColeta] = useState<boolean>(false)
    const [openRelatorioNaoColeta, setOpenRelatorioNaoColeta] = useState<boolean>(false)
    const [tabIndex, setTabIndex] = React.useState<number>(0)
    
    const clientDataTabs: TabData[] = [ 
        {label: 'Dados', component: <Dados />},
        {label: 'Endereço', component: <Endereco />},
        {label: 'Contatos', component: <Contato />},
        {label: 'Pontos Coleta', component: <PontoColeta />},
        {label: 'Mon. Mensal', component: <MonMensal />},
        {label: 'Mon. Anual', component: <MonAnual />},
        {label: 'Med. Vazão', component: <TabHidrometro />},
    ]

    useEffect(() => {
        getRoteiro(dispatch)
        getRamoAtividade(dispatch)
        getAbastecimento(dispatch)
        getPontosColeta(dispatch, Number(idCliente))
        get("Parametro", dispatch)
        getColor(dispatch, Number(idCliente))
    }, [dispatch, idCliente])
    /*
    const handleSalvarDadosParaPDF = useCallback(async () => {
        await getDadosAnalise(dispatch, Number(idCliente))
    }, [dispatch, idCliente])

    const handleSalvarDadosDBOParaPDF = useCallback(async () => {
        await getDadosDBO( Number(idCliente))
    }, [idCliente])*/

    return(
        <> 
            <Section name = "data">
                <SectionBox 
                    title = {`Cliente  ${cliente?.nome}`} 
                    padding = {false} 
                    goBack
                    right = {
                        <>
                            <SectionOption icon = {mdiClipboardTextOff} tooltip = "Histórico de coletas não conformes" onClick = {() => {getHistoricoColetaNaoConformidade(dispatch, Number(idCliente)); setOpenRelatorioNaoColeta(true)}} />
                            <SectionOption icon = {mdiClipboardTextClock} tooltip = "Histórico de coletas" onClick = {() => {getHistoricoColeta(dispatch, Number(idCliente)); setOpenRelatorioColeta(true)}} />
                        </>
                    }
                >
                    <Tab data = {clientDataTabs} index = {tabIndex} setIndex = {setTabIndex} />
                </SectionBox>
            </Section>
            <>
                <Modal width = {`100%`} open = {openRelatorioColeta} setOpen = {setOpenRelatorioColeta} title = "Histórico de Coletas">
                    <TableListarHistoricoColeta 
                        id = {Number(idCliente)}
                        lista = {historicoColeta} 
                        loading = {requestGetHistoricoColeta.loading} 
                    />
                </Modal>
                <Modal width = {`80%`} open = {openRelatorioNaoColeta} setOpen = {setOpenRelatorioNaoColeta} title = "Histórico de Coletas Não Conformidades">
                    <TableListarHistoricoNaoConformidade
                        id = {Number(idCliente)}
                        lista = {historicoColetaNaoConformidade}
                        loading = {requestGetHistoricoColetaNaoConformidade.loading}
                    />
                </Modal>
            </>
        </>
    )

}

export default Client